// extracted by mini-css-extract-plugin
module.exports = {"list":"_1bonXMjQ","list-item":"_2CPTMrD2","listItem":"_2CPTMrD2"};